import React, { useState } from 'react';
import {
    AppBar,
    Box,
    Toolbar,
    Button,
    IconButton,
    Menu,
    MenuItem,
    useMediaQuery,
} from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import logo from '../../assets/images/logo/logo.png';
import { authService } from '../../services/authService';

const LogoImg = styled('img')({
    height: 40,
    marginRight: 12,
    cursor: 'pointer',
    '&:hover': {
        opacity: 0.8,
    },
});

type TopbarProps = {
    onDrawerToggle: () => void;
};

const Topbar: React.FC<TopbarProps> = ({ onDrawerToggle }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleMyAccount = () => {
        navigate('/my-account');
        handleClose(); // Close the menu if it's open
    };

    const handleLogout = () => {
        authService.logout();
        navigate('/login');
        handleClose(); // Close the menu if it's open
    };

    const handleLogoClick = () => {
        navigate('/');
    };

    return (
        <AppBar
            position='fixed'
            color='inherit'
            elevation={0}
            sx={{
                zIndex: theme.zIndex.drawer + 1,
                height: 64,
                justifyContent: 'center',
                borderBottom: '1px solid #E0E0E0',
                width: '100%',
                px: isMobile ? 1 : 4,
            }}
        >
            <Toolbar
                disableGutters
                sx={{
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    minHeight: '64px !important',
                }}
            >
                {/* Left Section */}
                <Box display='flex' alignItems='center' gap={1}>
                    {isMobile && (
                        <IconButton edge='start' onClick={onDrawerToggle}>
                            <MenuIcon />
                        </IconButton>
                    )}
                    <LogoImg src={logo} alt='Gensize' onClick={handleLogoClick} />
                </Box>

                {/* Right Section */}
                <Box display='flex' alignItems='center'>
                    {isMobile ? (
                        <>
                            <Button
                                onClick={handleMenuClick}
                                endIcon={<ArrowDropDownIcon />}
                                sx={{
                                    color: '#0A1D56',
                                    textTransform: 'none',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                    minWidth: 0,
                                }}
                            >
                                <AccountCircleIcon />
                            </Button>
                            <Menu
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                            >
                                <MenuItem onClick={handleMyAccount} sx={{color:"#132F5F"}}>
                                    <AccountCircleIcon sx={{ mr: 1 }} /> My Account
                                </MenuItem>
                                <MenuItem onClick={handleLogout} sx={{color:"#FF544B"}}>
                                    <LogoutOutlinedIcon sx={{ mr: 1 }} /> Log Out
                                </MenuItem>
                            </Menu>
                        </>
                    ) : (
                        <>
                            <Button
                                startIcon={<AccountCircleIcon />}
                                onClick={handleMyAccount}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 500,
                                    color: '#0A1D56',
                                    fontSize: '14px',
                                }}
                            >
                                My Account
                            </Button>
                            <Button
                                startIcon={<LogoutOutlinedIcon />}
                                onClick={handleLogout}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 500,
                                    color: '#FF544B',
                                    fontSize: '14px',
                                }}
                            >
                                Log Out
                            </Button>
                        </>
                    )}
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Topbar;
